import React from 'react';
import { Phone, MessageCircle, Mail, MapPin, Facebook, Instagram, Linkedin, ShieldCheck } from 'lucide-react';
import { FOOTER_LINKS, AGENT } from '../mock/mock';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#1a0d33] via-[#2A1257] to-[#1a0d33] text-white">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 pt-14 pb-6">
        <div className="grid lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-3">
            <Logo variant="light" />
            <p className="mt-4 text-sm text-purple-200/80 leading-relaxed">
              PhonePe Business Solutions by Premium Account Executive — serving merchants across the Himalayas with heart & hustle.
            </p>
          </div>

          {/* Quick */}
          <div className="lg:col-span-2">
            <div className="text-sm font-extrabold text-white uppercase tracking-wider mb-4">Quick Links</div>
            <ul className="space-y-2.5">
              {FOOTER_LINKS.quick.map((l) => (
                <li key={l.label}><a href={l.href} className="text-sm text-purple-200/80 hover:text-white transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-2">
            <div className="text-sm font-extrabold text-white uppercase tracking-wider mb-4">Our Solutions</div>
            <ul className="space-y-2.5">
              {FOOTER_LINKS.services.map((l) => (
                <li key={l.label}><a href={l.href} className="text-sm text-purple-200/80 hover:text-white transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Coverage */}
          <div className="lg:col-span-2">
            <div className="text-sm font-extrabold text-white uppercase tracking-wider mb-4">Service Areas</div>
            <ul className="space-y-2.5">
              {FOOTER_LINKS.coverage.map((l) => (
                <li key={l.label}><a href={l.href} className="text-sm text-purple-200/80 hover:text-white transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <div className="text-sm font-extrabold text-white uppercase tracking-wider mb-4">Contact</div>
            <ul className="space-y-2.5 text-sm text-purple-200/80">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> {AGENT.phone}</li>
              <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-emerald-400" /> {AGENT.whatsapp}</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> {AGENT.email}</li>
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {AGENT.coverage}</li>
            </ul>

            <div className="mt-5">
              <div className="text-sm font-extrabold text-white uppercase tracking-wider mb-3">Follow Us</div>
              <div className="flex gap-2">
                {[Facebook, Instagram, Linkedin].map((I, i) => (
                  <a key={i} href="#" className="w-10 h-10 rounded-xl bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                    <I className="w-4 h-4 text-white" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Verified badge strip */}
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-2xl bg-white/5 border border-white/10">
            <ShieldCheck className="w-4 h-4 text-emerald-400" />
            <span className="text-xs font-bold text-white">Authorized Premium Account Executive Partner</span>
          </div>
          <div className="text-xs text-purple-200/60 text-center md:text-right">
            © 2025 HimalayanPOS.com · All Rights Reserved · <a href="#" className="hover:text-white">Privacy Policy</a> · <a href="#" className="hover:text-white">Terms</a>
          </div>
        </div>

        <div className="mt-4 text-[11px] text-purple-200/50 leading-relaxed text-center md:text-left max-w-4xl">
          This website is operated by a PhonePe Premium Account Executive to help merchants request business solutions. PhonePe® is a registered trademark of its respective owner.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
